// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"m0-z"};